var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinylOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 15C13.657 15 15.0001 13.6569 15.0001 12C15.0001 10.3431 13.657 9 12.0001 9C10.3432 9 9.0001 10.3431 9.0001 12C9.0001 13.6569 10.3432 15 12.0001 15ZM12.0001 13.2C12.6628 13.2 13.2001 12.6627 13.2001 12C13.2001 11.3373 12.6628 10.8 12.0001 10.8C11.3374 10.8 10.8001 11.3373 10.8001 12C10.8001 12.6627 11.3374 13.2 12.0001 13.2Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4001 12C7.4001 9.45949 9.45959 7.4 12.0001 7.4C12.4972 7.4 12.9001 6.99706 12.9001 6.5C12.9001 6.00294 12.4972 5.6 12.0001 5.6C8.46548 5.6 5.6001 8.46538 5.6001 12C5.6001 12.4971 6.00304 12.9 6.5001 12.9C6.99715 12.9 7.4001 12.4971 7.4001 12Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 12C18.4001 11.5029 17.9972 11.1 17.5001 11.1C17.003 11.1 16.6001 11.5029 16.6001 12C16.6001 14.5405 14.5406 16.6 12.0001 16.6C11.503 16.6 11.1001 17.0029 11.1001 17.5C11.1001 17.9971 11.503 18.4 12.0001 18.4C15.5347 18.4 18.4001 15.5346 18.4001 12Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99974 4.99964C6.7903 3.20908 9.26654 2.1 12.0001 2.1C14.7337 2.1 17.2099 3.20908 19.0005 4.99964C20.791 6.7902 21.9001 9.26644 21.9001 12C21.9001 14.7336 20.791 17.2098 19.0005 19.0004C17.2099 20.7909 14.7337 21.9 12.0001 21.9C9.26654 21.9 6.7903 20.7909 4.99974 19.0004C3.20918 17.2098 2.1001 14.7336 2.1001 12C2.1001 9.26644 3.20918 6.7902 4.99974 4.99964ZM12.0001 3.9C9.76309 3.9 7.73933 4.80564 6.27253 6.27243C4.80574 7.73923 3.9001 9.763 3.9001 12C3.9001 14.237 4.80574 16.2608 6.27253 17.7276C7.73933 19.1944 9.7631 20.1 12.0001 20.1C14.2371 20.1 16.2609 19.1944 17.7277 17.7276C19.1945 16.2608 20.1001 14.237 20.1001 12C20.1001 9.763 19.1945 7.73923 17.7277 6.27243C16.2609 4.80564 14.2371 3.9 12.0001 3.9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylOutline);
export default __webpack_public_path__ + "static/media/vinyl_outline.39b8e25d100bdf4d5186dc74ba92bce0.svg";
export { ForwardRef as ReactComponent };